<template>
  <el-dialog
    :visible="visible"
    width="630px"
    custom-class="strategy-risk-confirm"
    append-to-body
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    @closed="$emit('closed')"
  >
    <div class="strategy-risk-confirm__head">
      <h2>{{ dialogTitle }}</h2>
      <button type="button" :aria-label="$t('关闭')" @click="close">
        <i class="el-icon-close" aria-hidden="true" />
      </button>
    </div>

    <ul class="strategy-risk-confirm__list">
      <li>{{ $tk('robot.warn1') }}</li>
      <li>{{ $tk('robot.warn2') }}</li>
      <li>{{ $tk('robot.warn3') }}</li>
      <li class="is-danger">{{ $tk('robot.warn5') }}</li>
      <li class="is-danger">{{ $tk('robot.warn6') }}</li>
      <li class="is-danger">
        {{ $t('UPlus对您的任何交易概不负责，包括但不限于担保或赔偿。点击“确认”即表示您同意这些条款。') }}
      </li>
    </ul>

    <div class="strategy-risk-confirm__accept">
      <label class="strategy-risk-confirm__checkbox" for="strategy-risk-accepted">
        <input
          id="strategy-risk-accepted"
          v-model="accepted"
          type="checkbox"
          :aria-label="$t('点击查看《UPlus智能量化交易协议》')"
        />
        <span aria-hidden="true">
          <i class="el-icon-check" />
        </span>
      </label>
      <span>
        <label for="strategy-risk-accepted">{{ $t('我已阅读和了解相关协定，并已知晓风险') }}</label>
        <button type="button" @click="$emit('agreement')">
          {{ $t('点击查看《UPlus智能量化交易协议》') }}
        </button>
      </span>
    </div>

    <div class="strategy-risk-confirm__actions">
      <button
        class="is-confirm"
        :class="{ 'is-waiting': !accepted }"
        type="button"
        :aria-disabled="accepted ? 'false' : 'true'"
        @click="confirm"
      >
        {{ $t('进入交易') }}
      </button>
      <button class="is-leave" type="button" @click="close">{{ $t('暂不交易，离开') }}</button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'StrategyRiskConfirmModal',
  props: {
    visible: { type: Boolean, default: false },
    product: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      accepted: false
    }
  },
  computed: {
    dialogTitle() {
      const kind = this.product.kind
      const key = this.product.key || ''
      if (kind === 'orbit' || key === 'orbit') return this.$tk('robot.Smart_furures_Warning6')
      if (kind === 'astra' || key === 'astra') return this.$tk('robot.Smart_furures_Warning7')
      if (kind === 'term') return this.$tk('robot.Smart_furures_Warning1')
      if (kind === 'bb') return this.$tk('robot.Smart_furures_Warning2')
      if (kind === 'grid') return this.$tk('robot.Smart_furures_Warning3')
      if (kind === 'martin') return this.$tk('robot.Smart_furures_Warning4')
      if (kind === 'vip' || key.indexOf('futures-x') === 0) {
        return this.$tk('robot.Smart_furures_Warning5')
      }
      return this.$tk('robot.Smart_furures_Warning')
    }
  },
  watch: {
    visible(value) {
      if (value) this.accepted = false
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    confirm() {
      if (!this.accepted) {
        this.$message.warning(this.$tk('robot.Please_read_Trading_Agreement'))
        return
      }
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.strategy-risk-confirm__head {
  position: relative;
  min-height: 32px;
  padding: 0 42px;
}

.strategy-risk-confirm__head h2 {
  margin: 0;
  color: rgba(0, 0, 0, .85);
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 32px;
}

.strategy-risk-confirm__head button {
  position: absolute;
  top: 0;
  right: 0;
  display: grid;
  width: 32px;
  height: 32px;
  padding: 0;
  place-items: center;
  color: #909399;
  border: 0;
  border-radius: 8px;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
}

.strategy-risk-confirm__head button:hover {
  color: #1f6bff;
  background: #f4f7fc;
}

.strategy-risk-confirm__list {
  max-height: min(400px, 52vh);
  margin: 20px 0 0;
  padding: 0 4px 0 27px;
  overflow-y: auto;
  color: #3a3f4e;
  font-size: 14px;
  line-height: 22px;
}

.strategy-risk-confirm__list li {
  list-style: disc;
}

.strategy-risk-confirm__list li + li {
  margin-top: 7px;
}

.strategy-risk-confirm__list .is-danger {
  color: #e12020;
}

.strategy-risk-confirm__list::-webkit-scrollbar {
  width: 5px;
}

.strategy-risk-confirm__list::-webkit-scrollbar-thumb {
  border-radius: 99px;
  background: #d8dce5;
}

.strategy-risk-confirm__accept {
  display: flex;
  margin-top: 20px;
  align-items: flex-start;
  color: #3a3f4e;
  font-size: 14px;
  line-height: 22px;
}

.strategy-risk-confirm__checkbox {
  position: relative;
  display: inline-flex;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  margin-top: 2px;
  cursor: pointer;
}

.strategy-risk-confirm__checkbox input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  clip-path: inset(50%);
}

.strategy-risk-confirm__checkbox > span {
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  color: transparent;
  border: 1px solid #b8bfcc;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
  font-size: 12px;
  transition: border-color .16s ease, background .16s ease, box-shadow .16s ease;
}

.strategy-risk-confirm__checkbox:hover > span {
  border-color: #1f6bff;
}

.strategy-risk-confirm__checkbox input:focus-visible + span {
  box-shadow: 0 0 0 3px rgba(31, 107, 255, .16);
}

.strategy-risk-confirm__checkbox input:checked + span {
  color: #fff;
  border-color: #1f6bff;
  background: #1f6bff;
}

.strategy-risk-confirm__accept > span {
  margin-left: 10px;
}

.strategy-risk-confirm__accept > span > label {
  cursor: pointer;
}

.strategy-risk-confirm__accept button {
  padding: 0;
  color: #1f6bff;
  border: 0;
  border-bottom: 1px dashed #1f6bff;
  background: transparent;
  font: inherit;
  line-height: inherit;
  cursor: pointer;
}

.strategy-risk-confirm__actions {
  margin-top: 20px;
  text-align: center;
}

.strategy-risk-confirm__actions button {
  font-size: 14px;
  cursor: pointer;
}

.strategy-risk-confirm__actions .is-confirm {
  display: block;
  width: 80%;
  height: 42px;
  margin: 0 auto;
  color: #fff;
  border: 1px solid #1f6bff;
  border-radius: 8px;
  background: #1f6bff;
  font-size: 16px;
  font-weight: 700;
}

.strategy-risk-confirm__actions .is-confirm:hover {
  border-color: #1458da;
  background: #1458da;
}

.strategy-risk-confirm__actions .is-confirm.is-waiting {
  border-color: #8db1fa;
  background: #8db1fa;
}

.strategy-risk-confirm__actions .is-confirm.is-waiting:hover {
  border-color: #739ff5;
  background: #739ff5;
}

.strategy-risk-confirm__actions .is-leave {
  display: inline-block;
  margin: 10px auto 0;
  padding: 0;
  color: #1e2329;
  border: 0;
  border-bottom: 1px solid #1e2329;
  background: transparent;
}

@media (max-width: 680px) {
  .strategy-risk-confirm__head {
    padding: 0 34px;
  }

  .strategy-risk-confirm__actions .is-confirm {
    width: 100%;
  }
}
</style>

<style>
.strategy-risk-confirm {
  max-width: calc(100vw - 30px);
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(23, 31, 53, .2);
}

.strategy-risk-confirm .el-dialog__header,
.strategy-risk-confirm .el-dialog__footer {
  display: none;
}

.strategy-risk-confirm .el-dialog__body {
  padding: 24px 30px 20px;
}
</style>
